/* -disable react/no-array-index-key */
/* -disable class-methods-use-this */
import React, { Component } from 'react';
import Icon from '../../../../../components/Icon';

import { Divider, HeaderContentWrapper } from './styles';
import { OrderTypes } from '../../../../../utils/OrderTypes';

export default class THead extends Component {
  _renderCellClass(headerAlignment) {
    switch (headerAlignment) {
      case 'right':
        return 'Table__cell--align-right';

      case 'center':
        return 'Table__cell--align-center';

      default:
        return '';
    }
  }

  _changeDataOrder = (key, order) => {
    const { onOrderColumn } = this.props;

    if (key && order) {
      onOrderColumn(key, order);
    }
  };

  // Renders <th> elements
  _renderTableHeaders(headers) {
    const { dataOrder, onOrderColumn } = this.props;

    return headers.map((header, index) => (
      <th
        key={`${header.title}-${index}`}
        className={`Table__cell ${this._renderCellClass(header.alignment)}`}
        width={header.width}
      >
        <HeaderContentWrapper
          alignLeft={header.alignLeft}
          onChangeDataOrder={onOrderColumn}
          onClick={
            onOrderColumn
              ? () => {
                  if (
                    dataOrder &&
                    header.fieldType === dataOrder.fieldType &&
                    dataOrder.orderType === OrderTypes.DESC
                  ) {
                    this._changeDataOrder(header.fieldType, OrderTypes.ASC);
                  } else if (
                    dataOrder &&
                    header.fieldType === dataOrder.fieldType &&
                    dataOrder.orderType === OrderTypes.ASC
                  ) {
                    this._changeDataOrder(header.fieldType, OrderTypes.DESC);
                  } else {
                    this._changeDataOrder(
                      header.fieldType,
                      dataOrder.orderType === OrderTypes.DESC
                        ? OrderTypes.ASC
                        : OrderTypes.DESC,
                    );
                  }
                }
              : null
          }
        >
          {header.title}
          {dataOrder && <Icon name="swap_vert" />}
        </HeaderContentWrapper>
      </th>
    ));
  }

  render() {
    const { headers } = this.props;

    return (
      <>
        <thead className="Table__thead">
          <tr>{this._renderTableHeaders(headers)}</tr>
        </thead>
        <Divider />
      </>
    );
  }
}
